import { useGetContext } from '@api/lendingAPI/lapiHooks';

import { getBanksFromContext } from './getBanksFromContext';
import { getLinkedAccounts } from './getLinkedAccounts';
import { useGetOnlineAccounts } from './useGetOnlineAccounts';

export const useGetLinkedAccounts = () => {
    const { data: onlineAccountsResponse } = useGetOnlineAccounts();
    const { data: context } = useGetContext();

    return getLinkedAccounts(
        onlineAccountsResponse,
        getBanksFromContext(context)
    );
};
